<template>
  <div :class="wrap">
    <div class="opacitybg d-flex align-items-center">
      <span class="text-h6 font-weight-regular numberHolder">
        {{ formattedTime }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Countdown",
  mounted() {
    this.timerId = setInterval(() => {
      const currentDate = new Date();
      const lunchTime = this.lunchDate - currentDate;

      // Calculate total seconds, then derive hours, minutes, seconds
      const totalSeconds = Math.floor(lunchTime / 1000);
      this.seconds = totalSeconds;
      this.minutes = Math.floor(this.seconds / 60);
      this.hours = Math.floor(this.minutes / 60);

      // Stop the interval if time runs out
      if (totalSeconds < 0) {
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
        clearInterval(this.timerId);
      }
    }, 1000);
  },
  props: {
    until: {
      type: String,
      required: true,
    },
    format: {
      type: String,
      default: "HHMMSS",
    },
    wrap: {
      type: String,
      default: "d-flex justify-space-around align-items-center text-center",
    },
  },
  data() {
    return {
      hours: 0,
      minutes: 0,
      seconds: 0,
      lunchDate: new Date(this.until),
      timerId: null,
    };
  },
  computed: {
    formattedTime() {
      // Format time as HH:MM:SS (e.g., 18:05:12)
      const formattedHours = String(this.hours).padStart(2, "0");
      const formattedMinutes = String(this.minutes % 60).padStart(2, "0");
      const formattedSeconds = String(this.seconds % 60).padStart(2, "0");
      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    },
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
};
</script>

<style scoped>
.opacitybg {
  padding: 10px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto; /* Allow width to fit content */
}

.numberHolder {
  font-size: 20px;
  font-weight: 400;
  color: #fff;
  font-family: monospace;
  white-space: nowrap; /* Keep all on the same line */
}

.d-flex {
  display: flex;
}

.justify-space-around {
  justify-content: space-around;
}

.align-items-center {
  align-items: center;
}

.text-center {
  text-align: center;
}
</style>
